import React, { useEffect, useState } from 'react';
import {Grid, Typography, Card, CardContent, Grid2} from '@mui/material';

interface WeatherData {
    date: string;
    temperature_2m_max: number;
    temperature_2m_min: number;
    weathercode: number;
}

const weatherCodeDescriptions: { [key: number]: string } = {
    0: 'Clear sky',
    1: 'Mainly clear, partly cloudy, and overcast',
    2: 'Mainly clear, partly cloudy, and overcast',
    3: 'Mainly clear, partly cloudy, and overcast',
    45: 'Fog and depositing rime fog',
    48: 'Fog and depositing rime fog',
    51: 'Drizzle: Light, moderate, and dense intensity',
    53: 'Drizzle: Light, moderate, and dense intensity',
    55: 'Drizzle: Light, moderate, and dense intensity',
    56: 'Freezing Drizzle: Light and dense intensity',
    57: 'Freezing Drizzle: Light and dense intensity',
    61: 'Rain: Slight, moderate and heavy intensity',
    63: 'Rain: Slight, moderate and heavy intensity',
    65: 'Rain: Slight, moderate and heavy intensity',
    66: 'Freezing Rain: Light and heavy intensity',
    67: 'Freezing Rain: Light and heavy intensity',
    71: 'Snow fall: Slight, moderate, and heavy intensity',
    73: 'Snow fall: Slight, moderate, and heavy intensity',
    75: 'Snow fall: Slight, moderate, and heavy intensity',
    77: 'Snow grains',
    80: 'Rain showers: Slight, moderate, and violent',
    81: 'Rain showers: Slight, moderate, and violent',
    82: 'Rain showers: Slight, moderate, and violent',
    85: 'Snow showers slight and heavy',
    86: 'Snow showers slight and heavy',
    95: 'Thunderstorm: Slight or moderate',
    96: 'Thunderstorm with slight and heavy hail',
    99: 'Thunderstorm with slight and heavy hail',
};

const getWeatherDescription = (code: number): string => {
    return weatherCodeDescriptions[code] || 'Unknown weather code';
};

export default function Weather() {
    const [weatherData, setWeatherData] = useState<WeatherData[]>([]);
    const [loading, setLoading] = useState(true);
    let latitude= 0;
    let longitude= 0;
    let [city, setCity] = useState('');

    const getLocation = async () => {
        await navigator.geolocation.getCurrentPosition(success, error, options);
    }

    const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
    };

    async function success(pos: { coords: any; }) {
        const crd = pos.coords;
        latitude = crd.latitude;
        longitude = crd.longitude;
        const response = await fetch(
            `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current=temperature_2m,rain,weather_code&hourly=temperature_2m&daily=weather_code,temperature_2m_max,temperature_2m_min,sunrise,sunset&timezone=Europe%2FBerlin`,
        );
        const data = await response.json();
        console.log(data); // Log the response data
        setWeatherData(data.daily.time.map((date: string, index: number) => ({
            date,
            temperature_2m_max: data.daily.temperature_2m_max[index],
            temperature_2m_min: data.daily.temperature_2m_min[index],
            weathercode: data.daily.weather_code[index], // Ensure the correct field name
        })));
        await fetch(`https://api.geoapify.com/v1/geocode/reverse?lat=${latitude}&lon=${longitude}&apiKey=25f3d25a12bb4fc6a73e2b00bb0e9577`)
            .then(response => response.json())
            .then(data => {
                console.log("getCity", data);
                setCity(data.features[0].properties.city);
            });
        setLoading(false);

    }

    function error(err: { code: any; message: any; }) {
        console.warn(`ERROR(${err.code}): ${err.message}`);
    }


    useEffect(() => {
        getLocation();
    }, []);

    if (loading) {
        return <Typography>Loading...</Typography>;
    }

    return (
    <Grid2>
        <Grid2>
            <Typography variant="h4" gutterBottom>
                {city}
            </Typography>
        </Grid2>
        <Grid container spacing={2}>
            {weatherData.map((day) => (
                <Grid item xs={12} sm={6} md={4} key={day.date}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6">
                                {new Date(day.date).toLocaleDateString('en-GB', {
                                    weekday: 'long',
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                })}
                            </Typography>
                            <Typography variant="body1">
                                Max: {day.temperature_2m_max}°C
                            </Typography>
                            <Typography variant="body1">
                                Min: {day.temperature_2m_min}°C
                            </Typography>
                            <Typography variant="body2">
                                {getWeatherDescription(day.weathercode)}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
            <Grid item style={{ width: '30%', height: 'auto', marginLeft: '230px' }}>
                <img src="/Pictures/Wetter.png" alt="Weather" style={{ width: '100%', height: 'auto' }} />
            </Grid>
        </Grid>
    </Grid2>
    );
}